import { toast } from "react-toastify";
import { _CargoManifest, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { useEffect } from "react";
import usePaginator from "../../../../theme/Component/usePaginator";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useModal, { MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { DropDown } from "../../../../theme/Component/DropDown";

interface Props {
    CargoManifest: any;
}

export const CargoManifestTransportGuides = ({ CargoManifest }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_CargoManifest);
    const paginador = usePaginator();

    const modalC = useModal("Eliminar Guia de Manifiesto", MODAL_SM)

    useEffect(() => {
        if (CargoManifest.IDCargoManifest) {
            getLista();
        }
    }, [CargoManifest])

    const getLista = () => {
        instance.getCargoManifestItemCatalog(CargoManifest.IDCargoManifest, CargoManifest.Since, paginador.page, 15).then(
            (resp) => {

                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)
                // setLista(resp.List)
                let x = resp.List;
                setLista(x)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID Guía', property: 'IDTransportGuide', visible: true },
        { title: 'Fecha Guía', property: 'TransportGuideDate', visible: true },
        { title: 'Número Guía', property: 'TransportGuideConsecutive', visible: true },
        { title: 'Código Pieza', property: 'TicketCode', visible: true },
        { title: 'Orígen', property: 'TransportDestinationOrigin', visible: true },
        { title: 'Destino', property: 'TransportDestinationDestinity', visible: true },
        { title: 'Tipo de Carga', property: 'GoodsTypeName', visible: true },
        { title: 'Estado de la Carga', property: 'GoodsStateName', visible: true },
        { title: 'Soporte de la Carga', property: 'GoodsSupportName', visible: true },
        { title: 'Peso (Kg)', property: 'WeightKg', visible: true },
        { title: 'Peso Real (Kg)', property: 'WeightKgReal', visible: true },
        { title: 'Longitud (Cm)', property: 'LongLength', visible: true },
        { title: 'Alto (Cm)', property: 'HightLength', visible: true },
        { title: 'Ancho (Cm)', property: 'WidthLength', visible: true },
        { title: 'Volumen (Cm3)', property: 'Volume', visible: true },

    ]

    const deleteItem = () => {
        instance.deleteCargoManifestItem(bean.TransportGuideDate, bean.IDCargoManifestItem).then(
            (resp) => {
                modalC.close()
                getLista();

            }
        ).catch(err => toast.error(err));
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Eliminar Guia de Manifiesto', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const modalcsv = useModal("Exportar Listado", MODAL_SM)

    // const buttons = () => {
    //     return (
    //         <div className="row">
    //             <div className="col-md-12">
    //                 {_single.canExport() &&
    //                     <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
    //                 }
    //             </div>
    //         </div>
    //     )
    // }

    // const actionsDropDown = [
    //     { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
    // ];

    // const actions = (e: any) => {

    //     if (e.id === 1) {
    //         getListaExport();
    //         modalcsv.open();
    //     }
    // }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    listButtons={listaBotones()}
                    rowSet={setBean}
                    records={paginador}
                />



                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.Name}</strong>
                </ModalConfirm>

            </div>
        </div>
    )
}